"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    login: {
        path: "/login",
    },
    provideCredentials: {
        path: "/provide-credentials",
    },
    logout: {
        path: "/logout",
    },
    adminLogin: {
        path: "/admin/login",
    },
    adminAccounts: {
        path: "/admin/accounts",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2Vzc2lvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9yb3V0aW5nL3Nlc3Npb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUFzQztBQUV6QixRQUFBLE1BQU0sR0FBRyxJQUFBLG1CQUFXLEVBQUM7SUFDaEMsS0FBSyxFQUFFO1FBQ0wsSUFBSSxFQUFFLFFBQVE7S0FDZjtJQUNELGtCQUFrQixFQUFFO1FBQ2xCLElBQUksRUFBRSxzQkFBc0I7S0FDN0I7SUFDRCxNQUFNLEVBQUU7UUFDTixJQUFJLEVBQUUsU0FBUztLQUNoQjtJQUNELFVBQVUsRUFBRTtRQUNWLElBQUksRUFBRSxjQUFjO0tBQ3JCO0lBQ0QsYUFBYSxFQUFFO1FBQ2IsSUFBSSxFQUFFLGlCQUFpQjtLQUN4QjtDQUNGLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGJ1aWxkUm91dGVzIH0gZnJvbSBcIi4vdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHJvdXRlcyA9IGJ1aWxkUm91dGVzKHtcbiAgbG9naW46IHtcbiAgICBwYXRoOiBcIi9sb2dpblwiLFxuICB9LFxuICBwcm92aWRlQ3JlZGVudGlhbHM6IHtcbiAgICBwYXRoOiBcIi9wcm92aWRlLWNyZWRlbnRpYWxzXCIsXG4gIH0sXG4gIGxvZ291dDoge1xuICAgIHBhdGg6IFwiL2xvZ291dFwiLFxuICB9LFxuICBhZG1pbkxvZ2luOiB7XG4gICAgcGF0aDogXCIvYWRtaW4vbG9naW5cIixcbiAgfSxcbiAgYWRtaW5BY2NvdW50czoge1xuICAgIHBhdGg6IFwiL2FkbWluL2FjY291bnRzXCIsXG4gIH0sXG59KTtcbiJdfQ==